import _ from 'lodash';
import { FormulaToolAiButton } from '@/aiAssistant/FormulaAiAssistantButton.atom';
import { ContainerWithHTML } from '@/core/ContainerWithHTML.atom';
import { Alert } from '@seeqdev/qomponents';
import type { FormulaErrorInterface } from '@/formula/formula.types';

export interface FormulaErrorMessageProps {
  error: FormulaErrorInterface;
  clearError: () => void;
  formula?: string;
}

export const FormulaErrorMessage = ({ error, clearError, formula }: FormulaErrorMessageProps) => {
  const arrowLine = `${_.repeat(' ', error.column - 1)}⬆\n`;
  return (
    <Alert variant="formulaError" extraClassNames="flexColumnContainer pt5 pr5 pb5 pl5" onClose={clearError}>
      <div className="flexFill">
        <div className="text-pre-wrap">{arrowLine}</div>
        <div className="sq-formula-error">
          <ContainerWithHTML content={error.message} />
          <FormulaToolAiButton variant="debug" formula={formula ?? ''} error={error} />
        </div>
      </div>
    </Alert>
  );
};
